class Timer {
  secondsPassed = 0;

  increaseTimer = () => {
    this.secondsPassed += 1;
  }
}

export default new Timer();
